import React from 'react'
import Section from '../Section'
import ExperienceUnit from '../ExperienceUnit'

import littleNomadLogo from '../../assets/images/projects/demo.png'

class ProjectsSection extends React.Component {
  render() {
    return (
      <Section title="Projects">
        <div className="row">
          <ExperienceUnit
            logo={littleNomadLogo}
            colour="#FFFFFF"
            title="Websites"
            link="https://www.deepakmishra.com/"
            timeperiod="2017 - ???"
            subtitle="Runs on React+Redux "
          />
        </div>
      </Section>
    )
  }
}

export default ProjectsSection



// WEBPACK FOOTER //
// ./src/components/ProjectsSection/index.js